import {Component, inject, makeStateKey,  PLATFORM_ID, REQUEST, TransferState} from '@angular/core';
import { RouterModule} from '@angular/router';

import {isPlatformBrowser, isPlatformServer, JsonPipe, NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {AppService} from "./app.service";
import {SeoService} from "./pages/seo.service";
import {DomSanitizer} from "@angular/platform-browser";


const HOST_KEY = makeStateKey<string>('host');




@Component({
  imports: [RouterModule, NgOptimizedImage, NgIf, JsonPipe, NgForOf],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {

   private request = inject(REQUEST, { optional: true });
   private platformId = inject(PLATFORM_ID);
   private transferState = inject(TransferState);
  private appService = inject(AppService);
   private seoService = inject(SeoService);


  host = ''
  site!: any;
  jsonLD:any;

  metrics = [
    {
      id:7,
      google:'G-CETGR4EYZJ',
      ya:'99958576',
      yaVerify:'85d739e5ed65128b'
    },{
    id:6,
      google:'',
      ya:'100447573',
      yaVerify: '42181d482cae943f'
    }
  ]

  constructor( private sanitizer: DomSanitizer,) {


    if(this.request && isPlatformServer(this.platformId)){
        const host =  this.request.headers.get('host')
        this.transferState.set(HOST_KEY, host);
        this.appService.host = host
    }else if(isPlatformBrowser(this.platformId)){
        this.appService.host = this.transferState.get(HOST_KEY, '')
    }

    //this.appService.host = this.host
    this.getSite()
  }

  async getSite(){
    //if(this.appService.host){
      const res = await this.appService.getSite();
      this.appService.site = res;
      this.site = res
      this.seoService.addPreConnect(`https://${this.site.host}`)

    if(this.site.jsonStore) {
      const jsonLD = [];
      jsonLD.push(this.site.jsonOrganization)
      jsonLD.push(this.site.jsonStore)
      this.jsonLD = JSON.stringify(jsonLD);
    }


      const metric =  this.metrics.find(m=>+m.id===+this.site.id)
    if(metric){
      if(metric.google && metric.google!=='') {
        this.seoService.addGoogleAnalytics(metric.google)
      }
      if(metric.ya && metric.ya!=='') {
        this.seoService.addYandexMetrika(metric.ya)
      }
      if(metric.yaVerify && metric.yaVerify!=='') {
        this.seoService.addYandexVerification(metric.yaVerify)
      }
    }
    //}
  }

  sanitizeJsonLD() {
    return this.sanitizer.bypassSecurityTrustHtml( `<script type="application/ld+json">${this.jsonLD}</script>`);
  }



}

